    
<nz-spin [nzSpinning]="loading">
    <div class="table-wrapper">
        <nz-table #nzTable [nzData]="threads" [nzBordered]="true" [nzPageSize]="10"  nzTableLayout="fixed">
            <thead>
                <tr>
                    <th nzWidth="5%" zShowExpand ></th>
                    <th nzWidth="75%" nzEllipsis>{{'threadlist'|translateTA}}</th>
                    <th nzWidth="10%">{{'action'|translateTA}}</th>
                </tr>
            </thead>
            <tbody>
                @for (data of nzTable.data; track data.threadName){
                <tr>
                    <td  [nzExpand]="expandSet.has(data.threadName)" (nzExpandChange)="onExpandChange(data.threadName, $event)"></td>
                    <td><div class="list-thread-info"><b>{{'servername'|translateTA}}</b> {{ data.servername }} <b>|</b> <b>{{'threadname'|translateTA}}:</b> {{ data.threadName }} <b>|</b> <b>{{'status'|translateTA}}:</b> {{ data.status|translateTA }} <b>|</b> <b>{{'interrupted'|translateTA}}:</b> {{ data.isInterrupted|translateTA }}</div></td>
                    <td>
                        <button nz-button nzType="primary" nzDanger (click)="killThread(item)">
                            <nz-icon nzType="delete" />
                            {{'kill'|translateTA}}
                        </button>
                    </td>
                </tr>
                <tr *ngIf="expandSet.has(data.threadName)">
                    <td colspan="3">
                        <div class="expanded-content">
                            {{ data.stack }}
                        </div>
                    </td>
                </tr>
                }
                
            </tbody>
        </nz-table>
    </div>
    
</nz-spin>